import {
  ACTIONS,
  useTemplateContext,
} from '@components/Contexts/TemplateContext';
import { Box } from '@wix/design-system';
import { FC, useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import MobileCarousel from '../../Carousels/MobileCarousel';
import WixStudioBanner from './WixStudioBanner';
import { EDITOR_TYPES } from '@common/types';
import MobileHeroInfo from './MobileHeroInfo';
import s from './MobileHero.module.scss';

interface Props {
  setPurchaseError: (isError: boolean) => void;
}

const MobileHero: FC<Props> = ({ setPurchaseError }) => {
  const { dispatch } = useTemplateContext();
  const {
    template: { platform },
  } = useTemplateContext();
  const { isIntersecting, ref } = useIntersectionObserver({});

  const isShowingStudioBanner = platform === EDITOR_TYPES.STUDIO;

  useEffect(() => {
    dispatch({ type: ACTIONS.SHOW_STICKY_CTAS, show: !isIntersecting });
  }, [isIntersecting]);

  return (
    <Box className={s.heroContainer} ref={ref}>
      <Box className={s.heroContent} direction="vertical">
        {isShowingStudioBanner && <WixStudioBanner />}
        <Box className={s.carouselContainer}>
          <MobileCarousel />
        </Box>
        <MobileHeroInfo setPurchaseError={setPurchaseError} />
      </Box>
    </Box>
  );
};

export default MobileHero;
